import React from "react";
import SvgMapper from "../../features/common/SvgMapper";

const VideoPreview = ({ 
  videoRef, 
  isVideoEnabled, 
  isMicEnabled,
  streamRef, 
  cameraStatusText, 
  caption 
}) => {
  return (
    <div className="bg-gray-900 rounded-lg aspect-video relative overflow-hidden">
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted={!isMicEnabled}
        className="w-full h-full object-cover"
      />
      {(!isVideoEnabled || !streamRef.current?.getVideoTracks()?.[0]?.enabled) && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
          <div className="text-center text-white">
            <div className="relative">
              <div className="w-32 h-32 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                {SvgMapper.user("w-16 h-16 text-white")}
              </div>

              {isVideoEnabled && (
                <div className="absolute top-2 right-2 w-4 h-4 bg-green-500 rounded-full animate-pulse"></div>
              )}

              <p className="text-xl font-semibold">{cameraStatusText}</p>
              <p className="text-sm opacity-75">{caption}</p>
            </div>
          </div>
        </div>
      )}

      <div className="absolute top-4 left-4 flex items-center space-x-2 bg-black/50 px-3 py-2 rounded-lg">
        <div className={`w-2 h-2 rounded-full animate-pulse ${isVideoEnabled ? 'bg-red-500' : 'bg-red-500'}`}></div>
        <span className="text-white text-sm">Preview</span>
      </div>
    </div>
  );
};

export default VideoPreview;

